import { AppWrapper, Grid } from '@alirosoftware/web-components';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import nextI18nNextConfig from '../next-i18next.config';
import React, { useMemo } from 'react';
import { GenericHeader } from '../components/shared/header/generic-header';
import { GetServerSidePropsContext } from 'next';
import { ForgotPasswordForm } from '../components/onboarding/forgot-password/forgot-password-form';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { ForgotPasswordSent } from '../components/onboarding/forgot-password/forgot-password-sent';
import { PasswordReset } from '../components/onboarding/forgot-password/password-reset';
import { PasswordResetForm } from '../components/onboarding/forgot-password/password-reset-form';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { LOGIN_PATH, PRIVACY_PATH, TERMS_PATH } from '../constants/routes';

export const getServerSideProps = async ({ locale }: GetServerSidePropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale || '', ['common'], nextI18nNextConfig)),
  },
});

export function ForgotPassword() {
  const { t } = useTranslation();
  const router = useRouter();
  const resetToken = useMemo(() => {
    return router.query.token ? String(router.query.token) : undefined;
  }, [router.query.token]);
  const [sentToEmail, setSentToEmail] = React.useState<string>();
  const [passwordReset, setPasswordReset] = React.useState<boolean>();

  return (
    <AppWrapper
      header={<GenericHeader showNav={false} />}
      wrapperClassName="forgot-password-page"
      links={{ terms: TERMS_PATH, privacy: PRIVACY_PATH }}
    >
      <Head>
        <title>inSpring - Forgot Password</title>
      </Head>
      <Grid.Container fluid>
        <Grid.Row>
          <Grid.Column colspan={12} colspanSm={12} colspanMd={8} colspanLg={6} colspanXl={4} className="u-pull-center">
            {!resetToken ? (
              sentToEmail ? (
                <ForgotPasswordSent email={sentToEmail} />
              ) : (
                <ForgotPasswordForm onSent={setSentToEmail} />
              )
            ) : passwordReset ? (
              <PasswordReset />
            ) : (
              <PasswordResetForm token={resetToken} onReset={() => setPasswordReset(true)} />
            )}
          </Grid.Column>
          {!passwordReset ? (
            <Grid.Column colspan={12} className="center">
              <Link href={LOGIN_PATH}>{t('backToLogin')}</Link>
            </Grid.Column>
          ) : null}
        </Grid.Row>
      </Grid.Container>
    </AppWrapper>
  );
}

export default ForgotPassword;
